import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSave, 
    faTimes, 
    faSearch, 
    faFilter, 
    faCheck, 
    faCheckCircle,
    faTimesCircle,
    faFileInvoice,
    faNotesMedical,
    faSync,
    faChevronLeft,
    faChevronRight,
    faEye,
    faTimes as faClose,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import Ordenes from '../ordenes/Index';

const id = window.location.pathname.split('/').pop()
const defaultLayout = Object.keys(DefaultLayout);
const layout = id ? id : defaultLayout

class Facturar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // Estados para filtros
            busqueda: '',
            eps: '',
            regimen: '',
            estado: '',
            fecha_desde: '',
            fecha_hasta: '',
            solo_revisados: false,
            
            // Estados para datos
            ordenes: [],
            total: 0,
            pagina_actual: 1,
            por_pagina: 50,
            ultima_pagina: 1,
            cargando: false,
            
            // Estados para selección masiva (cargados desde localStorage)
            ordenesSeleccionadas: this.cargarSeleccionadasStorage(),
            seleccionarTodos: false,
            epsSeleccionada: null,
            
            // Estados para modal de revisión
            showModalRevision: false,
            ordenActual: null,
            notaRevision: '',
            
            // Estados para modal de visualización de orden
            showModalOrden: false,
            ordenSeleccionada: null,
            
            // Estados para modal de facturación
            showModalFacturacion: false,
            epsFacturacion: '',
            regimenFacturacion: '',
            facturando: false,
            
            // Estados para filtros dinámicos
            empresas: [],
            regimenes: [],
            planes: [],
            modalidades: [],
            
            // Facturacion Extra
            planFacturacion: '',
            modalidadFacturacion: '',
            
            // Mensajes de advertencia
            warningMessage: '',
            
            errores: []
        };
    }

    // ============================================
    // FUNCIONES AUXILIARES PARA ALERTAS
    // ============================================
    
    mostrarAlerta = (icono, titulo, texto, timer = 2000) => {
        return Swal.fire({
            icon: icono,
            title: titulo,
            text: texto,
            timer: timer,
            timerProgressBar: true,
            showConfirmButton: true,
            confirmButtonText: 'Entendido',
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                if (container) {
                    container.style.zIndex = '2050';
                }
            }
        });
    };

    mostrarConfirmacion = async (titulo, texto, icono = 'warning') => {
        return await Swal.fire({
            title: titulo,
            text: texto,
            icon: icono,
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                if (container) {
                    container.style.zIndex = '2050';
                }
            }
        });
    };

    mostrarLoading = (titulo = 'Procesando...', texto = 'Por favor espere') => {
        Swal.fire({
            title: titulo,
            text: texto,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
                const container = document.querySelector('.swal2-container');
                if (container) {
                    container.style.zIndex = '2050';
                }
            }
        });
    };

    cerrarLoading = () => {
        Swal.close();
    };

    // ============================================
    // FUNCIONES DE LOCALSTORAGE
    // ============================================

    cargarSeleccionadasStorage = () => {
        try {
            const guardadas = localStorage.getItem('ordenesSeleccionadasFacturar');
            if (guardadas) {
                const data = JSON.parse(guardadas);
                if (data.eps && Array.isArray(data.ids)) {
                    this.setState({ epsSeleccionada: data.eps });
                    return data.ids;
                }
            }
            return [];
        } catch (error) {
            console.error('Error al cargar seleccionadas:', error);
            return [];
        }
    };

    guardarSeleccionadasStorage = (seleccionadas, eps) => {
        try {
            localStorage.setItem('ordenesSeleccionadasFacturar', JSON.stringify({
                ids: seleccionadas,
                eps: eps,
                fecha: new Date().toISOString()
            }));
            this.setState({ epsSeleccionada: eps });
        } catch (error) {
            console.error('Error al guardar seleccionadas:', error);
        }
    };

    // ============================================
    // FUNCIONES PRINCIPALES
    // ============================================

    componentDidMount() {
        this.cargarOrdenes();
    }

    cargarOrdenes = async (pagina = 1) => {
        this.setState({ cargando: true, warningMessage: '' });
        
        try {
            const params = {
                busqueda: this.state.busqueda,
                eps: this.state.eps,
                regimen: this.state.regimen,
                estado: this.state.estado,
                fecha_desde: this.state.fecha_desde,
                fecha_hasta: this.state.fecha_hasta,
                pagina: pagina,
                por_pagina: this.state.por_pagina
            };

            if (this.state.solo_revisados) {
                params.revisado = 'Si';
            }

            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            const response = await authAxios.post('/ordenes/mostrar_archivos_facturar', params);
            
            if (response.data.success) {
                const nuevasOrdenes = response.data.data;
                
                let seleccionadasValidas = [];
                let epsDeSeleccionadas = null;
                
                if (this.state.ordenesSeleccionadas.length > 0) {
                    const ordenesSeleccionadasEncontradas = nuevasOrdenes.filter(orden => 
                        this.state.ordenesSeleccionadas.includes(orden.id)
                    );
                    
                    if (ordenesSeleccionadasEncontradas.length > 0) {
                        const epsUnicas = [...new Set(ordenesSeleccionadasEncontradas.map(o => o.eps))];
                        
                        if (epsUnicas.length === 1) {
                            seleccionadasValidas = ordenesSeleccionadasEncontradas.map(o => o.id);
                            epsDeSeleccionadas = epsUnicas[0];
                        } else {
                            this.mostrarAdvertencia('Se detectaron órdenes de diferentes EPS. Se ha limpiado la selección.');
                        }
                    }
                }
                
                this.setState({
                    ordenes: nuevasOrdenes,
                    total: response.data.total,
                    pagina_actual: response.data.pagina_actual,
                    ultima_pagina: response.data.ultima_pagina,
                    empresas: response.data.empresas || [],
                    regimenes: response.data.regimenes || [],
                    planes: response.data.planes || [],
                    modalidades: response.data.modalidades || [],
                    ordenesSeleccionadas: seleccionadasValidas,
                    epsSeleccionada: epsDeSeleccionadas,
                    seleccionarTodos: seleccionadasValidas.length === nuevasOrdenes.length && nuevasOrdenes.length > 0
                });
                
                this.guardarSeleccionadasStorage(seleccionadasValidas, epsDeSeleccionadas);
            }
        } catch (error) {
            console.error('Error al cargar órdenes:', error);
            this.mostrarAlerta('error', 'Error', 'No se pudieron cargar las órdenes');
        } finally {
            this.setState({ cargando: false });
        }
    };

    mostrarAdvertencia = (mensaje) => {
        this.setState({ warningMessage: mensaje });
        setTimeout(() => {
            this.setState({ warningMessage: '' });
        }, 5000);
    };

    handleFilterChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    limpiarFiltros = () => {
        this.setState({
            busqueda: '',
            eps: '',
            regimen: '',
            estado: '',
            fecha_desde: '',
            fecha_hasta: '',
            solo_revisados: false
        }, () => {
            this.cargarOrdenes(1);
        });
    };

    buscar = () => {
        this.cargarOrdenes(1);
    };

    cambiarPagina = (nuevaPagina) => {
        if (nuevaPagina >= 1 && nuevaPagina <= this.state.ultima_pagina) {
            this.cargarOrdenes(nuevaPagina);
        }
    };

    puedeSeleccionarOrden = (orden) => {
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        
        if (ordenesSeleccionadas.length === 0) return true;
        return orden.eps === epsSeleccionada;
    };

    toggleSeleccionOrden = (id) => {
        this.setState(prevState => {
            const orden = prevState.ordenes.find(o => o.id === id);
            
            if (!prevState.ordenesSeleccionadas.includes(id)) {
                if (!this.puedeSeleccionarOrden(orden)) {
                    this.mostrarAdvertencia(`Solo puede seleccionar órdenes de la EPS ${this.getNombreEmpresa(prevState.epsSeleccionada)}`);
                    return prevState;
                }
            }
            
            let seleccionadas;
            let nuevaEpsSeleccionada = prevState.epsSeleccionada;
            
            if (prevState.ordenesSeleccionadas.includes(id)) {
                seleccionadas = prevState.ordenesSeleccionadas.filter(ordenId => ordenId !== id);
                
                if (seleccionadas.length === 0) {
                    nuevaEpsSeleccionada = null;
                }
            } else {
                seleccionadas = [...prevState.ordenesSeleccionadas, id];
                
                if (prevState.ordenesSeleccionadas.length === 0) {
                    nuevaEpsSeleccionada = orden.eps;
                }
            }
            
            this.guardarSeleccionadasStorage(seleccionadas, nuevaEpsSeleccionada);
            
            return {
                ordenesSeleccionadas: seleccionadas,
                epsSeleccionada: nuevaEpsSeleccionada,
                seleccionarTodos: seleccionadas.length === prevState.ordenes.length
            };
        });
    };

    toggleSeleccionarTodos = () => {
        this.setState(prevState => {
            let seleccionadas;
            let nuevaEpsSeleccionada = prevState.epsSeleccionada;
            
            if (prevState.seleccionarTodos) {
                seleccionadas = [];
                nuevaEpsSeleccionada = null;
            } else {
                const epsDisponibles = [...new Set(prevState.ordenes.map(o => o.eps))];
                
                if (epsDisponibles.length > 1) {
                    this.mostrarAdvertencia('Hay múltiples EPS en los resultados. Seleccione manualmente las órdenes de una misma EPS.');
                    return prevState;
                }
                
                seleccionadas = prevState.ordenes
                    .filter(orden => orden.revisado === 'Si' && orden.factura === 0)
                    .map(orden => orden.id);
                
                if (seleccionadas.length > 0) {
                    nuevaEpsSeleccionada = prevState.ordenes[0].eps;
                }
            }
            
            this.guardarSeleccionadasStorage(seleccionadas, nuevaEpsSeleccionada);
            
            return {
                ordenesSeleccionadas: seleccionadas,
                epsSeleccionada: nuevaEpsSeleccionada,
                seleccionarTodos: !prevState.seleccionarTodos
            };
        });
    };

    limpiarSeleccion = () => {
        this.setState({
            ordenesSeleccionadas: [],
            epsSeleccionada: null,
            seleccionarTodos: false
        });
        localStorage.removeItem('ordenesSeleccionadasFacturar');
    };

    getNombreEmpresa = (id) => {
        const empresa = this.state.empresas.find(e => e.id == id);
        return empresa ? empresa.nombre : `EPS ${id}`;
    };

    verOrdenModal = (orden) => {
        window.localStorage.setItem("Archivo", 200);
        window.localStorage.setItem("TablaId", orden.numero_archivo);
        
        this.setState({
            showModalOrden: true,
            ordenSeleccionada: orden
        });
    };

    cerrarModalOrden = () => {
        this.setState({
            showModalOrden: false,
            ordenSeleccionada: null
        });
        this.cargarOrdenes(this.state.pagina_actual);
    };

    abrirModalRevision = (orden) => {
        this.setState({
            showModalRevision: true,
            ordenActual: orden,
            notaRevision: orden.notas || ''
        });
    };

    cerrarModalRevision = () => {
        this.setState({
            showModalRevision: false,
            ordenActual: null,
            notaRevision: ''
        });
    };

    guardarRevision = async () => {
        if (!this.state.ordenActual) return;

        this.mostrarLoading('Revisando...', 'Por favor espere');

        try {
            const response = await authAxios.post('/ordenes/revisar', {
                id: this.state.ordenActual.numero_archivo,
                notas: this.state.notaRevision
            });

            this.cerrarLoading();

            if (response.data.success) {
                this.mostrarAlerta('success', '¡Revisado!', 'La orden ha sido marcada como revisada', 2000);
                this.cerrarModalRevision();
                this.cargarOrdenes(this.state.pagina_actual);
            } else {
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo revisar la orden');
            }
        } catch (error) {
            console.error('Error al revisar orden:', error);
            this.cerrarLoading();
            this.mostrarAlerta('error', 'Error', 'No se pudo revisar la orden');
        }
    };

    quitarRevision = async (orden) => {
        const result = await this.mostrarConfirmacion(
            '¿Quitar revisión?',
            `¿Está seguro de quitar la revisión de la orden #${orden.id}?`
        );

        if (!result.isConfirmed) return;

        this.mostrarLoading('Procesando...', 'Por favor espere');

        try {
            const response = await authAxios.post('/ordenes/desrevisar', {
                id: orden.id
            });

            this.cerrarLoading();

            if (response.data.success) {
                this.mostrarAlerta('success', '¡Actualizado!', 'Se ha quitado la revisión de la orden', 2000);
                
                if (this.state.ordenesSeleccionadas.includes(orden.id)) {
                    this.toggleSeleccionOrden(orden.id);
                }

                this.cargarOrdenes(this.state.pagina_actual);
            } else {
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo quitar la revisión');
            }
        } catch (error) {
            console.error('Error al quitar revisión:', error);
            this.cerrarLoading();
            this.mostrarAlerta('error', 'Error', 'No se pudo quitar la revisión');
        }
    };

    abrirModalFacturacion = () => {
        const { ordenesSeleccionadas, epsSeleccionada, eps, regimen } = this.state;

        if (ordenesSeleccionadas.length === 0) {
            this.mostrarAlerta('warning', 'Atención', 'Debe seleccionar al menos una orden para facturar');
            return;
        }

        const ordenesNoRevisadas = this.state.ordenes
            .filter(orden => ordenesSeleccionadas.includes(orden.id))
            .filter(orden => orden.revisado !== 'Si');

        if (ordenesNoRevisadas.length > 0) {
            this.mostrarAlerta('error', 'Error', 'Todas las órdenes deben estar revisadas antes de facturar');
            return;
        }

        this.setState({
            showModalFacturacion: true,
            epsFacturacion: epsSeleccionada || eps || '',
            regimenFacturacion: regimen || '',
            planFacturacion: '',
            modalidadFacturacion: ''
        });
    };

    cerrarModalFacturacion = () => {
        this.setState({
            showModalFacturacion: false,
            epsFacturacion: '',
            regimenFacturacion: '',
            planFacturacion: '',
            modalidadFacturacion: '',
            facturando: false
        });
    };

    handleEpsFacturacionChange = async (e) => {
        const nuevaEps = e.target.value;
        const { ordenesSeleccionadas, ordenes } = this.state;
        
        if (ordenesSeleccionadas.length > 0) {
            const epsActual = ordenes.find(o => ordenesSeleccionadas.includes(o.id))?.eps;
            
            if (nuevaEps && epsActual && nuevaEps !== epsActual) {
                // Primero cerramos el modal de facturación
                this.cerrarModalFacturacion();
                
                // Luego mostramos la confirmación
                const result = await this.mostrarConfirmacion(
                    '¿Cambiar EPS?',
                    `Las órdenes seleccionadas son de ${this.getNombreEmpresa(epsActual)}. Si cambia la EPS, se limpiará la selección actual.`
                );

                if (result.isConfirmed) {
                    this.limpiarSeleccion();
                    // Volvemos a abrir el modal con la nueva EPS
                    this.setState({ 
                        showModalFacturacion: true,
                        epsFacturacion: nuevaEps 
                    });
                } else {
                    // Si cancela, volvemos a abrir el modal con la EPS anterior
                    this.setState({ 
                        showModalFacturacion: true,
                        epsFacturacion: epsActual 
                    });
                }
                return;
            }
        }
        
        this.setState({ epsFacturacion: nuevaEps });
    };

    facturarSeleccionadas = async () => {
    const { ordenesSeleccionadas, epsFacturacion, regimenFacturacion, planFacturacion, modalidadFacturacion, ordenes } = this.state;

    if (!epsFacturacion) {
        this.mostrarAlerta('error', 'Error', 'Debe seleccionar la EPS para facturar');
        return;
    }

    if (!regimenFacturacion) {
        this.mostrarAlerta('error', 'Error', 'Debe seleccionar el régimen para facturar');
        return;
    }

    if (!modalidadFacturacion) {
        this.mostrarAlerta('error', 'Error', 'Debe seleccionar la modalidad de pago para facturar');
        return;
    }

    if (!planFacturacion) {
        this.mostrarAlerta('error', 'Error', 'Debe seleccionar el plan de servicio para facturar');
        return;
    }

    if (ordenesSeleccionadas.length > 0) {
        const epsDeOrdenes = ordenes.find(o => ordenesSeleccionadas.includes(o.id))?.eps;
        
        if (epsFacturacion !== epsDeOrdenes) {
            this.mostrarAlerta('error', 'Error', `La EPS seleccionada no coincide con la EPS de las órdenes (${this.getNombreEmpresa(epsDeOrdenes)})`);
            return;
        }
    }

    // Luego mostramos la confirmación
    const result = await this.mostrarConfirmacion(
        '¿Confirmar facturación?',
        `Va a facturar ${ordenesSeleccionadas.length} orden(es)`
    );

    if (!result.isConfirmed) {
        return;
    }
    
    // Solo cerramos el modal si se confirma
    this.cerrarModalFacturacion();

    const ordenesAFacturar = ordenes.filter(orden => ordenesSeleccionadas.includes(orden.numero_archivo));

    this.setState({ facturando: true });
    this.mostrarLoading('Facturando...', 'Por favor espere');

    try {
        const response = await authAxios.post('/ordenes/facturar', {
            ids: ordenesSeleccionadas,
            eps: epsFacturacion,
            regimen: regimenFacturacion,
            plan_servicio: planFacturacion,
            modalidad_pago: modalidadFacturacion,
            ordenes: ordenesAFacturar
        });

        this.cerrarLoading();

        if (response.data.status) {
            // Mostrar mensaje de éxito con el ID de la factura
            await this.mostrarAlerta(
                'success', 
                '¡Factura Generada!', 
                `Factura #${response.data.factura_id} generada correctamente para ${ordenesSeleccionadas.length} orden(es)`,
                4000
            );
            
            // Limpiar selección y localStorage
            this.limpiarSeleccion();
            
            // Limpiar localStorage explícitamente
            localStorage.removeItem('ordenesSeleccionadasFacturar');
            
            // Actualizar la lista de órdenes
            await this.cargarOrdenes(this.state.pagina_actual);
            
            this.setState({ facturando: false });
        } else {
            this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudieron facturar las órdenes');
            this.setState({ facturando: false });
        }
    } catch (error) {
        console.error('Error al facturar:', error);
        this.cerrarLoading();
        
        // Verificar si el error tiene una respuesta del servidor
        if (error.response && error.response.data) {
            this.mostrarAlerta('error', 'Error', error.response.data.message || 'No se pudieron facturar las órdenes');
        } else {
            this.mostrarAlerta('error', 'Error', 'No se pudieron facturar las órdenes');
        }
        
        this.setState({ facturando: false });
        
        // Reabrir el modal de facturación en caso de error
        this.setState({ showModalFacturacion: true });
    }
};



// Función para cargar órdenes actualizada con mejor manejo de errores
cargarOrdenes = async (pagina = 1) => {
    this.setState({ cargando: true, warningMessage: '' });
    
    try {
        const params = {
            busqueda: this.state.busqueda,
            eps: this.state.eps,
            regimen: this.state.regimen,
            estado: this.state.estado,
            fecha_desde: this.state.fecha_desde,
            fecha_hasta: this.state.fecha_hasta,
            pagina: pagina,
            por_pagina: this.state.por_pagina
        };

        if (this.state.solo_revisados) {
            params.revisado = 'Si';
        }

        Object.keys(params).forEach(key => {
            if (params[key] === '' || params[key] === null || params[key] === undefined) {
                delete params[key];
            }
        });

        const response = await authAxios.post('/ordenes/mostrar_archivos_facturar', params);
        
        if (response.data.success) {
            const nuevasOrdenes = response.data.data;
            
            // Después de facturar, las órdenes seleccionadas ya no deberían estar en la lista
            // por lo que limpiamos la selección
            let seleccionadasValidas = [];
            let epsDeSeleccionadas = null;
            
            // Solo validamos selecciones si hay órdenes seleccionadas
            if (this.state.ordenesSeleccionadas.length > 0) {
                const ordenesSeleccionadasEncontradas = nuevasOrdenes.filter(orden => 
                    this.state.ordenesSeleccionadas.includes(orden.id) && orden.factura === 0
                );
                
                if (ordenesSeleccionadasEncontradas.length > 0) {
                    const epsUnicas = [...new Set(ordenesSeleccionadasEncontradas.map(o => o.eps))];
                    
                    if (epsUnicas.length === 1) {
                        seleccionadasValidas = ordenesSeleccionadasEncontradas.map(o => o.id);
                        epsDeSeleccionadas = epsUnicas[0];
                    }
                }
            }
            
            this.setState({
                ordenes: nuevasOrdenes,
                total: response.data.total,
                pagina_actual: response.data.pagina_actual,
                ultima_pagina: response.data.ultima_pagina,
                empresas: response.data.empresas || [],
                regimenes: response.data.regimenes || [],
                planes: response.data.planes || [],
                modalidades: response.data.modalidades || [],
                ordenesSeleccionadas: seleccionadasValidas,
                epsSeleccionada: epsDeSeleccionadas,
                seleccionarTodos: seleccionadasValidas.length === nuevasOrdenes.length && nuevasOrdenes.length > 0
            });
            
            // Actualizar localStorage solo si hay selecciones válidas
            if (seleccionadasValidas.length > 0) {
                this.guardarSeleccionadasStorage(seleccionadasValidas, epsDeSeleccionadas);
            } else {
                // Si no hay selecciones válidas, limpiar localStorage
                localStorage.removeItem('ordenesSeleccionadasFacturar');
            }
        }
    } catch (error) {
        console.error('Error al cargar órdenes:', error);
        this.mostrarAlerta('error', 'Error', 'No se pudieron cargar las órdenes');
    } finally {
        this.setState({ cargando: false });
    }
};

    render() {
        const {
            busqueda, eps, regimen, estado,
            fecha_desde, fecha_hasta, solo_revisados,
            ordenes, cargando, total, pagina_actual, ultima_pagina,
            ordenesSeleccionadas, seleccionarTodos, epsSeleccionada,
            showModalRevision, ordenActual, notaRevision,
            showModalOrden, ordenSeleccionada,
            showModalFacturacion, epsFacturacion, regimenFacturacion, planFacturacion, modalidadFacturacion, facturando,
            empresas, regimenes, planes, modalidades,
            warningMessage
        } = this.state;

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                    <b>FACTURAR ARCHIVOS</b>
                                </h5>
                                <div>
                                    {epsSeleccionada && (
                                        <span className="badge bg-info me-2">
                                            EPS: {this.getNombreEmpresa(epsSeleccionada)}
                                        </span>
                                    )}
                                    {ordenesSeleccionadas.length > 0 && (
                                        <button
                                            className="btn btn-warning btn-sm me-2"
                                            onClick={this.limpiarSeleccion}
                                            title="Limpiar selección"
                                        >
                                            <FontAwesomeIcon icon={faTimes} /> Limpiar ({ordenesSeleccionadas.length})
                                        </button>
                                    )}
                                    <button
                                        className="btn btn-success btn-sm"
                                        onClick={this.abrirModalFacturacion}
                                        disabled={ordenesSeleccionadas.length === 0}
                                    >
                                        <FontAwesomeIcon icon={faFileInvoice} /> Facturar ({ordenesSeleccionadas.length})
                                    </button>
                                </div>
                            </div>

                            {warningMessage && (
                                <div className="alert alert-warning alert-dismissible fade show m-3" role="alert">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                    {warningMessage}
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => this.setState({ warningMessage: '' })}
                                    ></button>
                                </div>
                            )}

                            <div className="card-body">
                                {/* Filtros */}
                                <div className="row mb-4">
                                    <div className="col-md-12">
                                        <div className="card bg-secondary">
                                            <div className="card-body">
                                                <h6 className="mb-3">Filtros de búsqueda</h6>
                                                <div className="row">
                                                    <div className="col-md-3 mb-2">
                                                        <label>Búsqueda general</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="busqueda"
                                                            value={busqueda}
                                                            onChange={this.handleFilterChange}
                                                            placeholder="Orden externa, atención, paciente..."
                                                        />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>EPS</label>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="eps"
                                                            value={eps}
                                                            onChange={this.handleFilterChange}
                                                        >
                                                            <option value="">Todas las EPS</option>
                                                            {empresas.map(emp => (
                                                                <option key={emp.id} value={emp.id}>
                                                                    {emp.nombre} ({emp.nit})
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Régimen</label>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="regimen"
                                                            value={regimen}
                                                            onChange={this.handleFilterChange}
                                                        >
                                                            <option value="">Todos los regímenes</option>
                                                            {regimenes.map(reg => (
                                                                <option key={reg.id} value={reg.codigo}>
                                                                    {reg.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Fecha desde</label>
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            name="fecha_desde"
                                                            value={fecha_desde}
                                                            onChange={this.handleFilterChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Fecha hasta</label>
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            name="fecha_hasta"
                                                            value={fecha_hasta}
                                                            onChange={this.handleFilterChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Estado</label>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="estado"
                                                            value={estado || ''}
                                                            onChange={this.handleFilterChange}
                                                        >
                                                            <option value="">Todos</option>
                                                            <option value="completadas">Completadas (100%)</option>
                                                            <option value="no_completadas">No completadas (&lt; 100%)</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-1 mb-2 d-flex align-items-end">
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                name="solo_revisados"
                                                                checked={solo_revisados}
                                                                onChange={(e) => this.setState({ solo_revisados: e.target.checked })}
                                                                id="soloRevisados"
                                                            />
                                                            <label className="form-check-label" htmlFor="soloRevisados">
                                                                Solo revisados
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            className="btn btn-primary btn-sm me-2"
                                                            onClick={this.buscar}
                                                        >
                                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                                        </button>
                                                        <button
                                                            className="btn btn-secondary btn-sm"
                                                            onClick={this.limpiarFiltros}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} /> Limpiar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tabla de resultados */}
                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered table-sm">
                                        <thead className="table-primary">
                                            <tr>
                                                <th width="40">
                                                    <input
                                                        type="checkbox"
                                                        checked={seleccionarTodos}
                                                        onChange={this.toggleSeleccionarTodos}
                                                        disabled={ordenes.length === 0}
                                                    />
                                                </th>
                                              {/*   <th>ID</th> */}
                                                <th>N. Archivo</th>
                                                <th>Paciente</th>
                                                <th>EPS</th>
                                                <th>Orden Externa</th>
                                              {/*   <th>Atención</th> */}
                                                <th>Diagnóstico</th>
                                                <th>Fecha Inicial</th>
                                                <th>Fecha Final</th>
                                                <th>Cantidad</th>
                                                <th>%</th>
                                                <th>Revisado</th>
                                                <th>Notas</th>
                                                <th width="80">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cargando ? (
                                                <tr>
                                                    <td colSpan="14" className="text-center">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="visually-hidden">Cargando...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : ordenes.length === 0 ? (
                                                <tr>
                                                    <td colSpan="14" className="text-center text-muted">
                                                        No hay órdenes para mostrar
                                                    </td>
                                                </tr>
                                            ) : (
                                                ordenes.map((orden) => {
                                                    const porcentaje = orden.porcentaje || 0;
                                                    const revisado = orden.revisado === 'Si';
                                                    const puedeFacturar = revisado && orden.factura === 0;
                                                    const puedeSeleccionar = this.puedeSeleccionarOrden(orden);
                                                    const seleccionada = ordenesSeleccionadas.includes(orden.id);
                                                    
                                                    return (
                                                        <tr 
                                                            key={orden.id} 
                                                            className={`${revisado ? 'table-success' : ''} ${seleccionada ? 'table-primary' : ''}`}
                                                        >
                                                            <td>
                                                                {puedeFacturar && (
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={seleccionada}
                                                                        onChange={() => this.toggleSeleccionOrden(orden.id)}
                                                                        disabled={!puedeSeleccionar && ordenesSeleccionadas.length > 0}
                                                                        title={!puedeSeleccionar && ordenesSeleccionadas.length > 0 ? 
                                                                            `Solo puede seleccionar órdenes de la misma EPS` : ''}
                                                                    />
                                                                )}
                                                            </td>
                                                           {/*  <td>{orden.id}</td> */}
                                                            <td>{orden.numero_archivo || '-'}</td>
                                                            <td>
                                                                {orden.nombre} {orden.apellido}
                                                                <br />
                                                                <small className="text-muted">CC: {orden.cedula}</small>
                                                            </td>
                                                            <td>
                                                                <span className="badge bg-secondary">
                                                                    {this.getNombreEmpresa(orden.eps)}
                                                                </span>
                                                            </td>
                                                            <td>{orden.orden_externa}</td>
                                                           {/*  <td>{orden.atencion}</td> */}
                                                            <td>{orden.diagnostico}</td>
                                                            <td>{orden.fecha_inicial}</td>
                                                            <td>{orden.fecha_final}</td>
                                                            <td className="text-center">{orden.cantidad}</td>
                                                            <td>
                                                                <div className="progress" style={{ height: '20px' }}>
                                                                    <div
                                                                        className={`progress-bar ${
                                                                            porcentaje >= 100 ? 'bg-success' :
                                                                            porcentaje >= 70 ? 'bg-info' :
                                                                            porcentaje >= 40 ? 'bg-warning' : 'bg-danger'
                                                                        }`}
                                                                        role="progressbar"
                                                                        style={{ width: `${porcentaje}%` }}
                                                                    >
                                                                        {porcentaje}%
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="text-center">
                                                                {revisado ? (
                                                                    <button
                                                                        className="btn btn-success btn-xs"
                                                                        onClick={() => this.quitarRevision(orden)}
                                                                        title="Quitar revisión"
                                                                    >
                                                                        <FontAwesomeIcon icon={faCheckCircle} className="me-1" /> Revisado
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-warning btn-xs"
                                                                        onClick={() => this.abrirModalRevision(orden)}
                                                                        title="Marcar como revisado"
                                                                    >
                                                                        <FontAwesomeIcon icon={faCheck} /> Revisar
                                                                    </button>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {orden.notas && (
                                                                    <span title={orden.notas}>
                                                                        <FontAwesomeIcon icon={faNotesMedical} className="text-info" />
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-info btn-xs"
                                                                    onClick={() => this.verOrdenModal(orden)}
                                                                    title="Ver orden"
                                                                >
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginación */}
                                {!cargando && ordenes.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Mostrando {ordenes.length} de {total} registros
                                        </div>
                                        <div>
                                            <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                onClick={() => this.cambiarPagina(pagina_actual - 1)}
                                                disabled={pagina_actual === 1}
                                            >
                                                <FontAwesomeIcon icon={faChevronLeft} /> Anterior
                                            </button>
                                            <span className="mx-2">
                                                Página {pagina_actual} de {ultima_pagina}
                                            </span>
                                            <button
                                                className="btn btn-sm btn-outline-primary ms-2"
                                                onClick={() => this.cambiarPagina(pagina_actual + 1)}
                                                disabled={pagina_actual === ultima_pagina}
                                            >
                                                Siguiente <FontAwesomeIcon icon={faChevronRight} />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de revisión */}
                {showModalRevision && (
                    <div
                        className="modal fade show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Revisar Orden #{ordenActual?.id}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={this.cerrarModalRevision}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Paciente:</label>
                                        <p className="form-control-static">
                                            {ordenActual?.nombre} {ordenActual?.apellido}
                                        </p>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">EPS:</label>
                                        <p className="form-control-static">
                                            {this.getNombreEmpresa(ordenActual?.eps)}
                                        </p>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Orden Externa:</label>
                                        <p className="form-control-static">{ordenActual?.orden_externa}</p>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Notas / Observaciones:</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={notaRevision}
                                            onChange={(e) => this.setState({ notaRevision: e.target.value })}
                                            placeholder="Ingrese alguna observación si es necesario..."
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={this.guardarRevision}
                                    >
                                        <FontAwesomeIcon icon={faCheck} /> Marcar como Revisado
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.cerrarModalRevision}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de visualización de orden */}
                {showModalOrden && ordenSeleccionada && (
                    <div
                        className="modal fade show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-xl modal-dialog-scrollable modal-fullscreen">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Detalle de Orden #{ordenSeleccionada.id} - {ordenSeleccionada.nombre} {ordenSeleccionada.apellido}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={this.cerrarModalOrden}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <Ordenes />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.cerrarModalOrden}
                                    >
                                        <FontAwesomeIcon icon={faClose} /> Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de facturación */}
                {showModalFacturacion && (
                    <div
                        className="modal fade show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070 }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Facturar {ordenesSeleccionadas.length} orden(es)
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={this.cerrarModalFacturacion}
                                        disabled={facturando}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-info">
                                        <strong>Resumen:</strong> {ordenesSeleccionadas.length} órdenes seleccionadas
                                        {epsSeleccionada && (
                                            <div>
                                                <strong>EPS de las órdenes:</strong> {this.getNombreEmpresa(epsSeleccionada)}
                                            </div>
                                        )}
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label className="form-label">
                                            EPS a facturar <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            className="form-control form-control-sm"
                                            value={epsFacturacion}
                                            onChange={this.handleEpsFacturacionChange}
                                            disabled={facturando}
                                        >
                                            <option value="">Seleccione una EPS</option>
                                            {empresas.map(emp => (
                                                <option key={emp.id} value={emp.id}>
                                                    {emp.nombre} ({emp.nit})
                                                </option>
                                            ))}
                                        </select>
                                        {epsSeleccionada && epsFacturacion && epsFacturacion !== epsSeleccionada && (
                                            <small className="text-danger">
                                                La EPS seleccionada no coincide con la EPS de las órdenes
                                            </small>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Régimen a facturar <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            className="form-control form-control-sm"
                                            value={regimenFacturacion}
                                            onChange={(e) => this.setState({ regimenFacturacion: e.target.value })}
                                            disabled={facturando}
                                        >
                                            <option value="">Seleccione un régimen</option>
                                            {regimenes.map(reg => (
                                                <option key={reg.id} value={reg.codigo}>
                                                    {reg.nombre}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">
                                                Modalidad de Pago <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                value={modalidadFacturacion}
                                                onChange={(e) => this.setState({ modalidadFacturacion: e.target.value })}
                                                disabled={facturando}
                                            >
                                                <option value="">Seleccione</option>
                                                {modalidades.map(mod => (
                                                    <option key={mod.id} value={mod.id || mod.codigo}>{mod.nombre}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">
                                                Plan de Servicio <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                value={planFacturacion}
                                                onChange={(e) => this.setState({ planFacturacion: e.target.value })}
                                                disabled={facturando}
                                            >
                                                <option value="">Seleccione</option>
                                                {planes.map(pl => (
                                                    <option key={pl.id} value={pl.id || pl.codigo}>{pl.nombre}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <h6>Órdenes a facturar:</h6>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            <table className="table table-sm table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Paciente</th>
                                                        <th>EPS</th>
                                                        <th>Orden Externa</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ordenes
                                                        .filter(orden => ordenesSeleccionadas.includes(orden.id))
                                                        .map(orden => (
                                                            <tr key={orden.id}>
                                                                <td>{orden.id}</td>
                                                                <td>{orden.nombre} {orden.apellido}</td>
                                                                <td>{this.getNombreEmpresa(orden.eps)}</td>
                                                                <td>{orden.orden_externa}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={this.facturarSeleccionadas}
                                        disabled={facturando || (epsSeleccionada && epsFacturacion !== epsSeleccionada)}
                                    >
                                        {facturando ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                Facturando...
                                            </>
                                        ) : (
                                            <>
                                                <FontAwesomeIcon icon={faFileInvoice} /> Confirmar Facturación
                                            </>
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.cerrarModalFacturacion}
                                        disabled={facturando}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Facturar;